import React from "react";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat({ number }) {
  const clean = (number || "").replace(/[^0-9]/g, "");
  const href = clean ? `https://wa.me/${clean}` : "#";
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Contacter par WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#20BA5A] text-white flex items-center justify-center shadow-2xl shadow-black/30 hover:scale-105 transition-transform"
    >
      <MessageCircle className="w-6 h-6 fill-white" strokeWidth={0} />
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-50 animate-ping" />
    </a>
  );
}
